module.exports = __webpack_public_path__ + "static/media/calendario.1929a43a.pdf";